import { useEffect, useReducer, useRef, useCallback } from "react";
import { io } from "socket.io-client";


const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://zahoor.me";
const MAX_LOG_ENTRIES = 50;

const addEntry = (log, message) =>
  [{ message, time: new Date().toLocaleTimeString() }, ...log].slice(0, MAX_LOG_ENTRIES);

const initialState = { connected: false, socketId: null, count: 0, log: [] };

const reducer = (state, action) => {
  switch (action.type) {
    case "CONNECTED":
      return { ...state, connected: true, socketId: action.payload.socketId,
        log: addEntry(state.log, `Connected (${action.payload.socketId})`),
      };
    case "DISCONNECTED":
      return { ...state, connected: false, socketId: null,
        log: addEntry(state.log, "Disconnected from server"),
      };
    case "COUNT_UPDATED":
      return { ...state, count: action.payload.count,
        log: addEntry(state.log, `Connection count → ${action.payload.count}`),
      };
    default:
      return state;
  }
};

const useSocket = () => {
  const socketRef = useRef(null);
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const socket = io(SOCKET_URL, { autoConnect: false });
    socketRef.current = socket;

    const onConnect = () =>
      dispatch({ type: "CONNECTED", payload: { socketId: socket.id } });
    const onDisconnect = () =>
      dispatch({ type: "DISCONNECTED" });
    const onCountUpdated = ({ count }) =>
      dispatch({ type: "COUNT_UPDATED", payload: { count } });

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connection_count", onCountUpdated);
    socket.on("welcome", onCountUpdated);

    socket.connect();

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connection_count", onCountUpdated);
      socket.off("welcome", onCountUpdated);
      socket.disconnect();
      socketRef.current = null;
    };
  }, []);

  const requestCount = useCallback(
    () => socketRef.current?.emit("request_count"),
    []
  );

  return { ...state, requestCount };
};

export default useSocket;